import { ctiApi } from '@/utils';

export default function handleDialpad({ state }, { interactionId, digit }) {
  if (!interactionId || !digit) {
    return Promise.reject(new Error('Missing interactionId or digit'));
  }

  return ctiApi({
    method: 'post',
    url: `dtmf`,
    data: { digit: digit, interactionId: interactionId }
  });
}